import React from 'react';
import './privacy.css';

const Privacy = () => {
  return (
    <div>
      <h1>Privacy Policy</h1>
      <p>We value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard your information when you visit our website or use our services.</p>
      
      <h2>1. Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul>
        <li><strong>Personal Information:</strong> This includes details such as your name, email address, and phone number.</li>
        <li><strong>Usage Data:</strong> We collect information about how you interact with our website and services, such as IP address, browser type, and device information.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We may use the information we collect for the following purposes:</p>
      <ul>
        <li><strong>To Provide Services:</strong> We use your information to deliver our services, including answering your queries and providing customer support.</li>
        <li><strong>To Improve Our Website:</strong> We may use your data to improve our website and enhance user experience.</li>
        <li><strong>For Marketing:</strong> We may use your information to send promotional emails, but you can opt-out at any time.</li>
      </ul>

      <h2>3. How We Protect Your Information</h2>
      <p>We take reasonable measures to protect your personal information from unauthorized access, disclosure, or alteration. This includes using encryption and secure servers to store your data.</p>

      <h2>4. Sharing Your Information</h2>
      <p>We may share your information in the following cases:</p>
      <ul>
        <li><strong>With Service Providers:</strong> We may share your information with trusted third-party vendors who help us deliver our services.</li>
        <li><strong>For Legal Compliance:</strong> If required by law, we may disclose your information to government authorities or law enforcement agencies to comply with legal obligations or in response to subpoenas, court orders, or other legal processes.</li>
        <li><strong>With Your Consent:</strong> We may share your information with third parties if you have given us explicit consent to do so.</li>
      </ul>

      <h2>5. Cookies and Tracking Technologies</h2>
      <p>We use cookies and similar tracking technologies to enhance your experience on our website. You can choose to disable cookies in your browser settings.</p>

      <h2>6. Your Rights</h2>
      <p>You have the right to access, update, or delete your personal information at any time. To exercise these rights, please contact us at [contact info].</p>

      <h2>7. Changes to This Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the date of the last update will be shown at the bottom.</p>

      <h2>8. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at [contact info].</p>
    </div>
  );
};

export default Privacy;
